/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_404Inputs */

const en_api_error_404 = /** @type {(inputs: Api_Error_404Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The requested resource could not be found.`)
};

const pt_br2_api_error_404 = /** @type {(inputs: Api_Error_404Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O recurso solicitado não pôde ser encontrado.`)
};

/**
* | output |
* | --- |
* | "The requested resource could not be found." |
*
* @param {Api_Error_404Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_404 = /** @type {((inputs?: Api_Error_404Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_404Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_404(inputs)
	return pt_br2_api_error_404(inputs)
});